import { createSlice } from '@reduxjs/toolkit';
const initialState = {
   sideBarActiveLink:null,
   parentLink:null
  };

  const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setSideBarActiveLink: (state, action) => {
        state.sideBarActiveLink = action.payload.activeLink;
      },
      setSideBarParentLink: (state, action) => {
        state.parentLink = action.payload.link;
      },
    }
  });
  // Action creators are generated for each case reducer function
export const { setSideBarParentLink,setSideBarActiveLink } = layoutSlice.actions;
export const selectSideBarActiveLink = (state) => state.layout.sideBarActiveLink;
export const selectParentLink = (state) => state.layout.parentLink;
export default layoutSlice.reducer;